// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: Arial, sans-serif;
  }
  
  .title h3{
    background-color: #6699cc;
    color: #ffffff;
    padding: 10px;
    text-align: left;
  }
  
  .center-content {
    margin: auto !important;
    text-align: center;
  }
  
  .mat-elevation-z8 {
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  }
  
  .mat-paginator {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  
  .button-container {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
  }
  
  th,
td {
  border: 1px solid white;
  text-align: center;
  padding: 8px;
}

th {
  background-color: #0b2d71 !important; 
  color: white !important; 
  font-weight: bold;
}

td a {
  color: blue; 
  text-decoration: none;
}
  
  td a:hover {
    text-decoration: underline;
  }
  
  .custom-dialog-container .mat-dialog-container {
    overflow: hidden;
  }
  .small-column{
    width: 100%;
  }

  .actions-width {
    width: 13%; 
  }
  .small-width {
    width: 10%; 
  }
  .little-width{
    width: 1%;
  }
`, "",{"version":3,"sources":["webpack://./src/app/modules/administrator/doa-categories/doa-categories.component.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,2HAA2H;EAC7H;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;EAClB;;EAEA;;EAEA,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;EAEE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;EACX","sourcesContent":["body {\n    font-family: Arial, sans-serif;\n  }\n  \n  .title h3{\n    background-color: #6699cc;\n    color: #ffffff;\n    padding: 10px;\n    text-align: left;\n  }\n  \n  .center-content {\n    margin: auto !important;\n    text-align: center;\n  }\n  \n  .mat-elevation-z8 {\n    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);\n  }\n  \n  .mat-paginator {\n    margin-top: 20px;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .button-container {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 20px;\n  }\n  \n  th,\ntd {\n  border: 1px solid white;\n  text-align: center;\n  padding: 8px;\n}\n\nth {\n  background-color: #0b2d71 !important; \n  color: white !important; \n  font-weight: bold;\n}\n\ntd a {\n  color: blue; \n  text-decoration: none;\n}\n  \n  td a:hover {\n    text-decoration: underline;\n  }\n  \n  .custom-dialog-container .mat-dialog-container {\n    overflow: hidden;\n  }\n  .small-column{\n    width: 100%;\n  }\n\n  .actions-width {\n    width: 13%; \n  }\n  .small-width {\n    width: 10%; \n  }\n  .little-width{\n    width: 1%;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
